import { TabStyles } from '../styles/TabStyles';
import { DropdownArrowSvg } from './resources/DropdownArrow';
import { ExpandoSvg } from './resources/Expando';
import { IconDropdownArrowSvg } from './resources/IconDropdownArrow';
import { MenuItemArrowSvg } from './resources/MenuItemArrow';
import { MenuItemCheckSvg } from './resources/MenuItemCheck';
import { SliderHandleSvg } from './resources/SliderHandle';
import { SliderLeftHandleSvg } from './resources/SliderLeftHandle';
import { SliderRightHandleSvg } from './resources/SliderRightHandle';
import { StepperLeftSvg } from './resources/StepperLeft';
import { StepperRightSvg } from './resources/StepperRight';

/**
 * For now, here's how to update these:
 * 1) Get the appropriate SVG file from Visual Design.
 * 2) Paste it into https://jakearchibald.github.io/svgomg/ with the default options, copy the minified code out.
 * 3) Paste that into https://www.base64encode.org/ and click "Encode".
 * 4) Ensure the <svg> element has `class="$state$"` and a <style> block for defining interactivity.
 * 5) Save to the resources/ folder and follow the pattern you see in here for other icons.
 */

const svgDataUriRegExp: RegExp = /^data\:image\/svg\+xml/;

export interface IconState {
  active?: boolean;
  checked?: boolean;
  disabled?: boolean;
  focus?: boolean;
  hover?: boolean;
  onDarkBackground?: boolean;
}

export interface DynamicSvgIcon {
  height: number;
  width: number;
  icon: (state?: IconState) => string;
  // tslint:disable-next-line:no-any
  [key: string]: any;
}

export function encodeSvg(svg: string): string {
  return svgDataUriRegExp.test(svg) ? svg : `data:image/svg+xml,${encodeURIComponent(svg)}`;
}

// Enable for TFS 799296 - "Add *.svg Resources Back and Update Code Playground"
// function decodeSvg(encodedSvg: string): string {
//   return svgDataUriRegExp.test(encodedSvg) ? atob(encodedSvg.substr(26)) : encodedSvg;
// }

function formatSvg(svgImport: string, state: IconState = {}): string {
  // tslint:disable-next-line:no-any
  const classList = Object.keys(state).filter(key => !!(state as any)[key]).join(' ');
  // FIXME need a different webpack loader to get rid of this, TFSID 793075
  return encodeSvg(svgImport.replace('$state$', classList));
}

export const DropdownArrowIcon: DynamicSvgIcon = {
  height: 18,
  width: 18,
  icon: (state?: IconState) => formatSvg(DropdownArrowSvg, state),
};

export const IconDropdownArrowIcon: DynamicSvgIcon = {
  height: 5,
  width: 7,
  icon: (state?: IconState) => formatSvg(IconDropdownArrowSvg, state),
};

export const MenuItemArrowIcon: DynamicSvgIcon = {
  height: 18,
  width: 18,
  icon: (state?: IconState) => formatSvg(MenuItemArrowSvg, state),
};

export const MenuItemCheckIcon: DynamicSvgIcon = {
  width: 10,
  height: 10,
  icon: (state?: IconState) => formatSvg(MenuItemCheckSvg, state),
  checkedItemPaddingLeft: TabStyles.Spacing.DefaultSpace * 2 + 10,
};

export const SliderHandleIcon: DynamicSvgIcon = {
  height: 20,
  width: 20,
  icon: (state?: IconState) => formatSvg(SliderHandleSvg, state),
};

export const SliderLeftHandleIcon: DynamicSvgIcon = {
  height: 20,
  width: 20,
  icon: (state?: IconState) => formatSvg(SliderLeftHandleSvg, state),
  artworkOffsetFromRightSide: 4,
};

export const SliderRightHandleIcon: DynamicSvgIcon = {
  height: 20,
  width: 20,
  icon: (state?: IconState) => formatSvg(SliderRightHandleSvg, state),
  artworkOffsetFromLeftSide: 2,
};

export const ExpandoIcon: DynamicSvgIcon = {
  height: 13,
  width: 13,
  icon: (state?: IconState) => formatSvg(ExpandoSvg, state),
};

export const StepperLeftIcon = {
  height: 22,
  width: 18,
  icon: (state?: IconState) => formatSvg(StepperLeftSvg, state),
};

export const StepperRightIcon = {
  height: 22,
  width: 18,
  icon: (state?: IconState) => formatSvg(StepperRightSvg, state),
};
